import { render, staticRenderFns } from "./edit_user_info.vue?vue&type=template&id=2dcc3a24&scoped=true&"
import script from "./edit_user_info.vue?vue&type=script&lang=js&"
export * from "./edit_user_info.vue?vue&type=script&lang=js&"
import style0 from "./edit_user_info.vue?vue&type=style&index=0&id=2dcc3a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc3a24",
  null
  
)

export default component.exports